import React from 'react';
import Note from './note'
import notesHelper from '../helper/notesHelper';
import errorHandlerHelper from '../helper/errorHandlerHelper';
import FilterNotes from './filterNotes';
class AllNotes extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isFilter: false,
            filteredNotes: [],
            allNotes: [],
            filterDate: ''
        }

        this.deleteNote = this.deleteNote.bind(this)
        this.setFilterDate = this.setFilterDate.bind(this)
        this.clearFilterDate = this.clearFilterDate.bind(this)
    }
    async componentDidMount() {
        try {
            this.setState({ isLoading: true })
            const token = this.props.token
            if (token) {
                const { response, data } = await notesHelper.getNoteHelper(token)
                if (response.ok) {
                    let allNotes = [];
                    let filteredNotes = []
                    data.forEach(element => {
                        allNotes.push(element)
                        filteredNotes.push(element)
                    });
                    this.setState({ allNotes, isLoading: false, filteredNotes })
                }
                else {
                    this.setState({ isLoading: false })
                    errorHandlerHelper.errorHandler(response, data, this.props.logout, this.props.history, this.props.showToast)
                }
            }
            else {
                //show error message
                this.setState({ isLoading: false })
                this.props.history.push('/login')
            }
        }
        catch (err) {
            console.error(err)
        }
    }
    setFilterDate(date) {
        let notes = this.state.allNotes
        let filterString = new Date(date)
        let filterDay = filterString.getDate()
        let filterMonth = filterString.getMonth()
        let filterYear = filterString.getFullYear()
        let filteredNotes = notes.filter((element) => {
            let eleDate = new Date(element.createdAt)
            if (eleDate.getDate() === filterDay && eleDate.getMonth() === filterMonth && eleDate.getFullYear() === filterYear) {
                return true
            }
            return false
        })
        this.setState({ filterDate: date, filteredNotes: filteredNotes })
        this.props.showToast('success', `Filtered diary for Date ${filterDay}-${filterMonth + 1}-${filterYear} `)
    }
    clearFilterDate() {
        let notes = this.state.allNotes
        let filteredNotes = []
        notes.forEach(ele => {
            filteredNotes.push(ele)
        })
        this.setState({ filterDate: '', filteredNotes: filteredNotes })
        this.props.showToast('success', `Filter Removed`)
    }
    renderListOfNotes(column) {
        let finalRenderList = []
        let eleList = []
        if (this.state.filteredNotes) {
            this.state.filteredNotes.forEach((element, index) => {
                let ele = <Note key={element._id} content={element?.content} createdAt={element?.createdAt} deleteNote={this.deleteNote} id={element._id} />
                eleList.push(ele)
                if (index !== 0 && ((index) % 3) === 0) {
                    let love = <div className="columns">
                        <div className="column is-one-third"> {eleList[0]}</div>
                        <div className="column is-one-third"> {eleList[1]}</div>
                        <div className="column is-one-third"> {eleList[2]}</div>
                    </div>
                    finalRenderList.push(love)
                    eleList = []
                    eleList.push(ele)
                }

            })
            if (eleList.length !== 0) {
                let localArr = []
                if (eleList[0]) {
                    localArr.push(
                        <div className="column is-one-third"> {eleList[0]}</div>
                    )
                }
                if (eleList[1]) {
                    localArr.push(
                        <div className="column is-one-third"> {eleList[1]}</div>
                    )
                }
                if (eleList[2]) {
                    localArr.push(
                        <div className="column is-one-third"> {eleList[2]}</div>
                    )
                }

                let wrap = <div className="columns" >{localArr}</div>
                finalRenderList.push(wrap)
            }

            return <>{finalRenderList}</>
        }


    }
    async deleteNote(noteId) {
        if (noteId) {
            this.setState({ isLoading: true })
            const { response, data } = await notesHelper.deleteNoteHelper(noteId, this.props.token)
            if (response.ok) {
                let notes = [...this.state.allNotes]
                let fNotes = [...this.state.filteredNotes]
                let allNotes = notes.filter((ele) => {
                    return ele._id !== noteId
                })
                let filteredNotes = fNotes.filter((ele) => {
                    return ele._id !== noteId
                })
                this.setState({ allNotes, isLoading: false, filteredNotes })
                this.props.showToast('success', 'Successfully deleted the diary note')
            }
            else {
                // console.log('gaand phat gaya iska')
                this.setState({ isLoading: false })
                errorHandlerHelper.errorHandler(response, data, this.props.logout, this.props.history, this.props.showToast)
            }
        }
    }
    renderEmptyMessage() {
        return <div className="columns is-centered">
            <div className="column is-half">
                <img src="/cat.png" alt="logo" style={{ maxHeight: "50%", width: "auto", display: "block", margin: "0 auto" }} />
                <p className="has-text-centered is-size-2">Wow such empty!</p>
            </div>
        </div>
    }
    renderLoader() {
        if (this.state.isLoading) {
            return <div class="pageloader is-active"><span class="title">Loading...</span></div>
        }
        return <></>
    }
    render() {
        return (
            <>
                {this.renderLoader()}
                <div className="box is-centered">
                    {this.state.filteredNotes.length > 0 ? this.renderListOfNotes() : this.renderEmptyMessage()}
                    <FilterNotes filterDate={this.setFilterDate} clearFilter={this.clearFilterDate} showToast={this.props.showToast} />
                </div>
            </>

        )

    }
}

export default AllNotes